import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash.get';
import { generateReactKey } from '../../../../../../utils/shared/commonUtils';

const RubricSection = ({ oralCompResult, mapper }) => (
    <section className="rubric-section section-block">
        {oralCompResult.items.map((oralCompItem, index) => {
            const { rubricType, score } = oralCompItem;
            const { items, description } = get(mapper, rubricType, { items: [] });
            return (
                <div key={generateReactKey(index)} className="rubric-item">
                    <div className="section-header">{description}</div>
                    {items.map((typeItem, itemIndex) => {
                        const number = itemIndex + 1;
                        return (
                            <div
                                key={generateReactKey(index, itemIndex)}
                                className={`section-item ${score === number ? 'active' : ''}`}
                            >
                                <span className="number">{number}</span>
                                {typeItem}
                            </div>
                        );
                    })}
                </div>
            );
        })}
    </section>
);

RubricSection.defaultProps = {
    oralCompResult: { items: [] },
    mapper: {},
};

RubricSection.propTypes = {
    oralCompResult: PropTypes.object,
    mapper: PropTypes.object,
};

export default RubricSection;
